import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import WebinarRegister from "@/pages/WebinarRegister";
import WatchRoom from "@/pages/WatchRoom";
import Account from "@/pages/Account";
import PayResume from "@/pages/PayResume";
import AdminLogin from "@/pages/AdminLogin";
import AdminReset from "@/pages/AdminReset";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import WebinarsList from "@/pages/admin/WebinarsList";
import WebinarEditor from "@/pages/admin/WebinarEditor";
import RegistrantsPage from "@/pages/admin/RegistrantsPage";
import Campaigns from "@/pages/admin/Campaigns";
import Community from "@/pages/admin/Community";
import Transactions from "@/pages/admin/Transactions";
import Profile from "@/pages/admin/Profile";
import Team from "@/pages/admin/Team";
import UsersPage from "@/pages/admin/UsersPage";
import MessagesPage from "@/pages/admin/MessagesPage";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors style={{ zIndex: 99999 }} />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/w/:slug" element={<WebinarRegister />} />
            <Route path="/watch/:registrantId" element={<WatchRoom />} />
            <Route path="/account" element={<Account />} />
            <Route path="/account/reset" element={<Account />} />
            <Route path="/pay/:registrantId" element={<PayResume />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/reset" element={<AdminReset />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="webinars" element={<WebinarsList />} />
              <Route path="webinars/:id" element={<WebinarEditor />} />
              <Route path="webinars/:id/registrants" element={<RegistrantsPage />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="community" element={<Community />} />
              <Route path="transactions" element={<Transactions />} />
              <Route path="profile" element={<Profile />} />
              <Route path="team" element={<Team />} />
              <Route path="users" element={<UsersPage />} />
            <Route path="messages" element={<MessagesPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
